import React, { FC } from 'react';
import styled from 'styled-components';
import { BackButton } from '../buttons';
import { PageHeaderContainer } from './pageHeaderContainer';

interface IHeaderProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    onBackClick?: () => void;
    backLabel?: React.ReactNode;
    isBackVisible?: boolean;
    steps?: React.ReactNode;
    actions?: React.ReactNode;
    learnMoreLabel?: string;
    learnMoreUrl?: string;
}

const _PageHeader: FC<IHeaderProps> = ({
    title,
    description,
    onBackClick,
    backLabel,
    isBackVisible = true,
    steps,
    actions: action,
    learnMoreLabel,
    learnMoreUrl
}) => {
    return (
        <PageHeaderContainer>
            {(isBackVisible || steps) && (
                <PageHeaderContainer.BackSteps>
                    {isBackVisible && <BackButton onClick={onBackClick}>{backLabel}</BackButton>}
                    {steps && <PageHeaderContainer.Steps>{steps}</PageHeaderContainer.Steps>}
                </PageHeaderContainer.BackSteps>
            )}
            {(title || description) && (
                <PageHeaderContainer.TitleDescription>
                    {title && <PageHeaderContainer.Title>{title}</PageHeaderContainer.Title>}
                    {(description || learnMoreUrl) && (
                        <PageHeaderContainer.Description $hasDescription={!!description}>
                            {description}
                            {learnMoreUrl && (
                                <>
                                    <PageHeaderContainer.LearnMore href={learnMoreUrl} target='_blank'>
                                        {learnMoreLabel ? learnMoreLabel : 'Learn more'}
                                    </PageHeaderContainer.LearnMore>
                                </>
                            )}
                        </PageHeaderContainer.Description>
                    )}
                </PageHeaderContainer.TitleDescription>
            )}
            {action && <PageHeaderContainer.Buttons>{action}</PageHeaderContainer.Buttons>}
        </PageHeaderContainer>
    );
};

export const PageHeader = styled(_PageHeader)``;
